export const FontFamilies = {
  sansSerif: "Roboto, sans-serif",
};
